// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4657":"15cc2d52","8914":"af58574f"}[chunkId] + ".chunk.css";
};